import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import { Card } from '@hivebrite/design-system/Card';

const NoMoreMembershipsToPurchase = () => (
  <Card>
    <Box mb={3} font="h4-regular">
      {s__(
        'Memberships|You already have subscribed to all available memberships, view them on your My Memberships page',
      )}
    </Box>
    <Button as="a" href={Routes.me_my_memberships_path()} variant="primary">
      {s__('Memberships|My Memberships')}
    </Button>
  </Card>
);

export default NoMoreMembershipsToPurchase;
